import ApplicationController from '../application_controller'

class PortalAbilitiesController extends ApplicationController {
  connect () {
    this.updateAllParents()
  }

  parentClick (event) {
    const checkbox = event.target

    if (this.isChild(checkbox)) {
      this.updateParentState(checkbox.dataset.parentId)
    } else {
      this.toggleParent(checkbox)
    }
  }

  isChild (checkbox) {
    return checkbox.closest('[data-parent-id]')
  }

  findChildren (parentId) {
    return this.element.querySelectorAll(`input[type="checkbox"][data-parent-id="${parentId}"]`)
  }

  findParent (parentId) {
    return this.element.querySelector(`input[type="checkbox"]#${parentId}`)
  }

  toggleParent (parentCheckbox) {
    const children = this.findChildren(parentCheckbox.id)

    if (parentCheckbox.classList.contains('indeterminate')) {
      parentCheckbox.classList.remove('indeterminate')
      parentCheckbox.checked = true
      children.forEach(ch => ch.checked = true)
      return
    }

    children.forEach(ch => ch.checked = parentCheckbox.checked)
  }

  updateParentState (parentId) {
    const parent = this.findParent(parentId)
    const children = this.findChildren(parentId)
    if (children.length === 0) return

    const checkedCount = Array.from(children).filter(ch => ch.checked).length

    if (checkedCount === children.length) {
      parent.checked = true
      parent.classList.remove('indeterminate')
    } else if (checkedCount === 0) {
      parent.checked = false
      parent.classList.remove('indeterminate')
    } else {
      parent.checked = false
      parent.classList.add('indeterminate')
    }
  }

  updateAllParents () {
    const parents = this.element.querySelectorAll('input[type=checkbox]:not([data-parent-id])')

    parents.forEach(parentCheckbox => this.updateParentState(parentCheckbox.id))
  }
}

export default PortalAbilitiesController
